import { get } from 'lodash';
import { useRouter } from 'next/router';
import { FC, Fragment, useContext, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useRecoilState, useRecoilValue } from 'recoil';
import AddressForm from '~/components/AddressForm';
import Checkbox from '~/components/Checkbox';
import Icon from '~/components/Icon';
import Input from '~/components/Input';
import AddressItem from '~/components/Items/AddressItem';
import FilterItem from '~/components/Items/FilterItem';
import AddressModal from '~/components/Modals/AddressModal';
import RadioGroup from '~/components/Radio/RadioGroup';
import SkeletonByTimeout from '~/components/Skeletons/SkeletonByTimeout';
import Text from '~/components/Text';
import Colors from '~/constants/colors';
import { CheckoutContext } from '~/contexts/checkout.context';
import { CartAtom } from '~/services/cart';
import { UserAddress, UserAtom } from '~/services/user';

const ShippingInfo: FC<any> = ({ formik }) => {
    // const { formik } = useContext(CheckoutContext);
    const [currentUser, setCurrentUser] = useRecoilState(UserAtom.currentUser);
    const { loading } = useRecoilValue(CartAtom.cartSelector);

    const [isAddNew, setIsAddNew] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState<Partial<UserAddress>>();
    const selectedShippingAddress = currentUser?.shipping_address?.find(
        (ba) => ba.id === formik.values?.shipping_address?.id
    );
    const handleAddNewAddress = () => {
        setIsAddNew(!isAddNew);
        if (isAddNew) {
            const defaultAddress = currentUser?.shipping_address?.find((ship) => ship.default_shipping);
            formik.setFieldValue('shipping_address', defaultAddress);
        } else {
            formik.setFieldValue?.('shipping_address', {
                city: '',
                firstname: '',
                lastname: '',
                postcode: '',
                street: '',
                street1: '',
                telephone: '',
                country_code: '',
                region_code: '',
                region_id: ''
            });
        }
    };

    const router = useRouter();
    useEffect(() => {
        // if (currentUser?.billing_address?.length) {
        //   let defaultAddress = currentUser?.billing_address.find(
        //     (address) => address.is_default
        //   );
        //   if (!defaultAddress) {
        //     defaultAddress = currentUser?.billing_address[0];
        //   }
        //   formik.setFieldValue?.("billing_address", defaultAddress);
        // }
    }, []);

    const handleRemoveAddressFromUser = (addressId: number) => {
        // if (formik.values?.billing_address?.id === addressId) {
        //   formik.setFieldValue?.("billing_address", {
        //     address: "",
        //     city: "",
        //     country: "",
        //     email: "",
        //     firstname: "",
        //     lastname: "",
        //     phone_number: "",
        //     zip_code: "",
        //     region: "",
        //     id: "",
        //     is_default: false,
        //   });
        // }
        // setCurrentUser((prevCurrentUser) => ({
        //   ...prevCurrentUser,
        //   billing_address:
        //     prevCurrentUser?.billing_address?.filter(
        //       (address) => address.id !== addressId
        //     ) || [],
        // }));
    };

    const handleSetAsDefault = (addressId: number) => {
        setCurrentUser((prevCurrentUser) => ({
            ...prevCurrentUser,
            shipping_address:
                prevCurrentUser?.shipping_address?.map((address) => {
                    if (address.id === addressId) {
                        return {
                            ...address,
                            default_shipping: true
                        };
                    }

                    return {
                        ...address,
                        default_shipping: false
                    };
                }) || []
        }));
    };

    const handleChangeAddress = (newAddress: UserAddress) => {
        if (newAddress?.id) {
            // setCurrentUser((prevCurrentUser) => ({
            //   ...prevCurrentUser,
            //   billing_address:
            //     prevCurrentUser?.billing_address?.map((address) => {
            //       if (address.id === newAddress?.id) {
            //         return {
            //           ...address,
            //           ...newAddress,
            //         };
            //       }
            //       return address;
            //     }) || [],
            // }));
            // formik.setFieldValue?.("billing_address", newAddress);
        } else {
            // setCurrentUser((prevCurrentUser) => ({
            //   ...prevCurrentUser,
            //   billing_address: (
            //     (prevCurrentUser?.billing_address?.map((address) => ({
            //       ...address,
            //       is_default: newAddress.is_default ? false : address.is_default,
            //     }))! as UserAddress[]) || []
            //   ).concat([{ ...newAddress, id: new Date().toISOString() }]),
            // }));
        }
    };

    return (
        <Fragment>
            <Text type="title-4" className="text-grey-900">
                SHIPPING ADDRESS
            </Text>
            {!currentUser?.token && (
                <Input
                    label="Email address"
                    required
                    id="email"
                    placeholder="Enter your email"
                    {...formik.getFieldProps?.('email')}
                    error={
                        // get(formik, `touched.email`) &&
                        get(formik, `errors.email`)
                    }
                    disabled={loading}
                />
            )}
            {currentUser?.token ? (
                <div className="flex flex-col gap-3">
                    <div className="flex-col gap-2 hidden lg:flex">
                        {!currentUser.shipping_address?.length && (
                            <SkeletonByTimeout timeOut={10000} renderAfterLoading={<Text>No shipping address</Text>}>
                                <Skeleton className="w-full aspect-square" height={35 * 5}></Skeleton>
                            </SkeletonByTimeout>
                        )}
                        {currentUser.shipping_address?.map((address: UserAddress, index) => (
                            <AddressItem
                                key={index}
                                data={address}
                                order={index + 1}
                                variant="checkbox"
                                showTagDefault={false}
                                onEdit={() => {
                                    setSelectedAddress(address);
                                }}
                                // onRemove={() => handleRemoveAddressFromUser(address.id)}
                                // onSetAsDefault={() => handleSetAsDefault(address.id)}
                                checked={formik.values?.shipping_address?.id === address.id}
                                onChecked={(checked) => {
                                    if (checked) {
                                        formik.setFieldValue?.('shipping_address', {
                                            ...address,
                                            street: Array.isArray(address.street)
                                                ? address.street?.[0]
                                                : address.street,
                                            street1:
                                                Array.isArray(address.street) && !!address.street?.[1]
                                                    ? address.street?.[1]
                                                    : '',
                                            country_code: address.country_code,
                                            region_code: address.region.region_code,
                                            region_id: address.region.region_id
                                        });
                                        setIsAddNew(false);
                                    }
                                }}
                            />
                        ))}
                    </div>
                    <div className="flex flex-col gap-2 lg:hidden">
                        {selectedShippingAddress && (
                            <AddressItem
                                data={selectedShippingAddress}
                                order={1}
                                variant="checkbox"
                                showTagDefault={false}
                                onEdit={() => {
                                    setSelectedAddress(selectedShippingAddress);
                                }}
                                // onRemove={() =>
                                //   handleRemoveAddressFromUser(selectedShippingAddress.id)
                                // }
                                // onSetAsDefault={() =>
                                //   handleSetAsDefault(selectedShippingAddress.id)
                                // }
                                checked
                                onChecked={(checked) => {
                                    if (checked) {
                                        formik.setFieldValue?.('shipping_address', selectedShippingAddress);
                                    }
                                }}
                            />
                        )}
                        {(currentUser.shipping_address?.filter((address) => address.id !== selectedShippingAddress?.id)
                            ?.length || 0) > 0 && (
                            <FilterItem title="Another addresses">
                                {currentUser.billing_address
                                    ?.filter((address) => address.id !== selectedShippingAddress?.id)
                                    .map((address, index) => (
                                        <AddressItem
                                            key={index}
                                            data={address}
                                            order={index + 1}
                                            variant="checkbox"
                                            showTagDefault={false}
                                            onEdit={() => {
                                                setSelectedAddress(address);
                                            }}
                                            // onRemove={() => handleRemoveAddressFromUser(address.id)}
                                            // onSetAsDefault={() => handleSetAsDefault(address.id)}
                                            checked={formik.values?.shipping_address?.id === address.id}
                                            onChecked={(checked) => {
                                                if (checked) {
                                                    formik.setFieldValue?.('shipping_address', address);
                                                }
                                            }}
                                        />
                                    ))}
                            </FilterItem>
                        )}
                    </div>
                    <div className="flex gap-2 items-center cursor-pointer" onClick={handleAddNewAddress}>
                        <Icon name="add" color={Colors.PRIMARY} />
                        <Text type="label-3" color={Colors.PRIMARY}>
                            {'Add New Address'}
                        </Text>
                    </div>
                    {isAddNew && (
                        <AddressForm key="shipping_address" formik={formik} type="shipping_address" loading={loading} />
                    )}
                </div>
            ) : (
                <AddressForm key="shipping_address" formik={formik} type="shipping_address" loading={loading} />
            )}
            <Text type="title-4" className="text-grey-900">
                BILLING ADDRESS
            </Text>
            <RadioGroup
                value={!!formik.values.same_as_shipping ? 'same_as_shipping' : 'is_difference_address'}
                onChange={(e) => {
                    formik.setFieldValue('same_as_shipping', e.target.value === 'same_as_shipping');
                    formik.setFieldValue('billing_address', {});
                }}
                className="flex flex-col gap-2"
                options={[
                    {
                        label: 'Same as Shipping Address',
                        value: 'same_as_shipping'
                    },
                    {
                        label: 'Use a different Billing Address',
                        value: 'is_difference_address'
                    }
                ]}
            />

            {!formik.values?.same_as_shipping && (
                <Fragment>
                    <AddressForm key="billing_address" formik={formik} type="billing_address" />
                </Fragment>
            )}

            <AddressModal
                open={!!selectedAddress}
                selectedAddress={selectedAddress}
                onClose={() => setSelectedAddress(undefined)}
                isCheckoutPage={true}
                isSaveAddress
            />
        </Fragment>
    );
};

export default ShippingInfo;
